import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import { useFlag } from '../../../flags';

import Button from '../../../components/Button/Button';
import logo from '../../../static/images/logo.png';
import { pushNotificationWithTimeout } from 'modules/notifications/notificationsSlice';

import colors from '../../../theme/Colors.module.scss';
import 'scenes/app/menuNav/MenuNav.scss';
import './CompanyHeader.scss';

import { Box, Text, Flex } from '@chakra-ui/react';

import { defaultDates } from 'helpers/presetDateHelpers';

import { apiSlice } from 'app/apiSlice';
import { useLogoutMutation } from 'modules/app/appApi';
import {
  setDateRange,
  clearUser,
  // setAppMode,
} from 'modules/app/appSlice';

// const appModes = ['retailer', 'advertiser'];
// const customArrowStyle = {
//   top: '0.9rem',
//   color: colors.darkGrey,
// };

const CompanyHeader = props => {
  const {
    isMobile,
    // appMode,
    inTemplateEditor,
  } = props;

  const dispatch = useDispatch();

  const [logout] = useLogoutMutation();

  // Selectors
  // const appMode = useSelector(state => state.app.appMode);
  const token = useSelector(state => state.app.token);
  const sessionUser = useSelector(state => state.app.user);

  const logoStyle = {
    filter: inTemplateEditor && 'brightness(20)',
  };

  // const newAppMode = newMode => {
  //   if (newMode !== appMode) {
  //     newMode = appModes[0] && navigate('/dashboard');
  //     newMode = appModes[1] && navigate('/adv/dashboard');
  //     setAppMode(newMode);
  //   }
  // };

  const handleLogout = async () => {
    try {
      await logout().unwrap();

      // clear user state
      dispatch(clearUser());

      // clear all RTK Query cached data
      dispatch(apiSlice.util.resetApiState());

      //set initial date range
      dispatch(
        setDateRange({
          from: new Date(defaultDates.start),
          to: new Date(defaultDates.end),
        })
      );
      // TODO remove this hack to make per-session flags work
      window.localStorage.removeItem('FLAG_OVERRIDES'); // Clean localStorage
      dispatch(
        pushNotificationWithTimeout({
          type: 'success',
          message: 'Log out successfully',
        })
      );
    } catch (error) {
      dispatch(
        pushNotificationWithTimeout({
          type: 'error',
          message: 'Failed to log out.',
        })
      );
    }
  };

  const buildHeader = () => {
    if (token) {
      return (
        <>
          <Box className="brand">
            {(isMobile || inTemplateEditor) && (
              <Link to="/">
                <img
                  className="nav-brand__logo"
                  src={logo}
                  style={logoStyle}
                  alt="UnDigital Logo."
                />
              </Link>
            )}
          </Box>

          {!isMobile && (
            <Box className="company-summary">
              {!inTemplateEditor && (
                <>
                  <Text as="p" className="name">
                    <i className="fas fa-user"></i>&nbsp;
                    {/* TODO: Show company name and link to website when ready */}
                    {/* <a
                      href={sessionUser?.companySite}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {sessionUser?.name}
                    </a> */}
                  </Text>

                  <Text as="p" className="email">
                    {sessionUser?.email}
                  </Text>
                </>
              )}
            </Box>
          )}

          <Box className="auth-btn">
            <Button
              type="button"
              icon="signOut"
              text="Log out"
              border={false}
              textColor={inTemplateEditor ? colors.white : colors.slate}
              iconColor={inTemplateEditor ? colors.white : colors.primary900}
              btnStyle={inTemplateEditor ? 'solid' : 'transparent'}
              bgColor={inTemplateEditor && 'rgba(255, 255, 255, 0.1)'}
              hoverColor={inTemplateEditor && 'rgba(255, 255, 255, 0.25'}
              onClick={handleLogout}
            />
          </Box>
        </>
      );
    } else {
      return (
        <>
          {/* {isMobile && ( */}
          <Box className="brand">
            <Link to="/">
              <img
                className="nav-brand__logo"
                src={logo}
                style={logoStyle}
                alt="UnDigital Logo."
              />
            </Link>
          </Box>
          {/* )} */}

          <Box className="company-summary reset-password">
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <Text as="span" className="name">
                Welcome to UnDigital!
              </Text>
              <Text as="span" className="email">
                Personalized packaging
              </Text>
            </Flex>
          </Box>

          <Box className="auth-btn">
            <Button
              type="button"
              icon="signIn"
              text="Log in"
              border={false}
              textColor={inTemplateEditor ? colors.white : colors.slate}
              iconColor={inTemplateEditor ? colors.white : colors.primary900}
              btnStyle={inTemplateEditor ? 'solid' : 'transparent'}
              bgColor={inTemplateEditor && 'rgba(255, 255, 255, 0.1)'}
              hoverColor={inTemplateEditor && 'rgba(255, 255, 255, 0.25'}
              url="/login"
            />
          </Box>
        </>
      );
    }
  };

  return (
    <Box
      className="header-container"
      style={{
        height: inTemplateEditor && '3.65rem',
      }}
    >
      {buildHeader()}
    </Box>
  );
};

export default CompanyHeader;
